export default {
  SELENIUM: 'selenium',
  CYPRESS: 'cypress',
  ANY: 'any',
};
